import { getCart } from "@store/cart/actions";
import { selectProject } from "@store/project/actions";
import { selectRoles } from "@store/userRoles/actions";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

const AdminSettings = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    navigate("/admin-settings/users");
  }, []);

  useEffect(() => {
    // dispatch(selectProject(null));
    // dispatch(selectRoles(null));
    // dispatch(getCart(null));
  }, []);

  return <></>;
};

export default AdminSettings;
